import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { Link, useLocation } from "react-router-dom";
import "./sidebar.css";
import ClientB from "../Images/client.png";
import ClientR from "../Images/client-red.jpg";
import UserB from "../Images/user_red.png";
import UserR from "../Images/user_black.png";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../components/apiConfig";
import { HomeOutlined, SaveOutlined } from "@mui/icons-material";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { ChevronsLeft } from "lucide-react";

const Sidebar = () => {
  const [isHovered, setIsHovered] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedKey, setSelectedKey] = useState("1");
  const [userType, setUserType] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch user details to determine sidebar type
    const fetchUserDetails = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        const response = await fetch(`${BASE_URL}/user/get_user_details`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`Error: ${response.status}`);
        }

        const data = await response.json();
        console.log("User data:", data);
        setUserType(data.user_type);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching user details:", error);
        setLoading(false);
        // Set default user type if fetch fails
        setUserType("Admin"); // Default fallback
      }
    };

    fetchUserDetails();
  }, []);

  useEffect(() => {
    // Set selected key based on current path
    if (userType === "Admin") {
      const adminMenuKeyMap = {
        "/dashboard": "1",
        "/user": "2",
      };

      for (const [pattern, key] of Object.entries(adminMenuKeyMap)) {
        if (location.pathname.includes(pattern)) {
          setSelectedKey(key);
          break;
        }
      }
    } else if (userType === "Project Architect") {
      const architectMenuKeyMap = {
        "/architect": "1",
        "/reports": "2",
      };

      for (const [pattern, key] of Object.entries(architectMenuKeyMap)) {
        if (location.pathname.includes(pattern)) {
          setSelectedKey(key);
          break;
        }
      }
    }
  }, [location.pathname, userType]);

  const sidebarKey = location.pathname;

  if (
    location.pathname === "/login-page" ||
    location.pathname === "/view-role" ||
    location.pathname === "/user-management"
    // location.pathname.endsWith("/reports_view")
  ) {
    return null;
  }

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleMenuClick = (path) => {
    setIsHovered(false);
    navigate(path);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  const handleLocationMasterDownload = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        throw new Error("Unauthorized access. Please log in again.");
      }

      const response = await fetch(
        `${BASE_URL}/master_data/download_location_master`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          `Failed to fetch error glossary: ${response.statusText}`
        );
      }

      const data = await response.json();

      if (data.download_link) {
        window.location.href = data.download_link;
      }
    } catch (err) {
      console.error("Error downloading glossary:", err.message);
    }
  };

  console.log("Current user type:", userType);

  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <div
        key={sidebarKey}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          border: "none",
          zIndex: 8,
          width: isHovered ? "160px" : "80px",
          transition: "width 0.5s ease-in-out",
        }}
        className={`sider ${isHovered ? "expanded" : "collapsed"}`}
      >
        {/* Menu Header */}
        <div
          style={{
            padding: "20px 20px",
            // borderBottom: "1px solid #f0f0f0",
            display: "flex",
            alignItems: "center",
            height: "30px",
            boxSizing: "border-box",
            marginTop: "22px",
          }}
        >
          {/* <span style={{
            fontSize: "16px",
            fontWeight: "500",
            color: "#333",
            marginLeft:"8px"
          }}>
            <ChevronsLeft style={{color:"black"}}/>
          </span>
          {isHovered && (
            <span style={{
              fontSize: "14px",
              // fontWeight: "500",
              color: "black",
              marginLeft: "14px",
              fontFamily:"Inter"

            }}>
              Menu
            </span>
          )} */}
        </div>

        {userType === "Admin" ? (
          // Admin Sidebar
          <Menu
            mode="inline"
            selectedKeys={[selectedKey]}
            style={{
              border: "none",
              background: "none",
              marginTop: "0px", // Changed from 60px to 0px since we have the header now
            }}
          >
            <Menu.Item
              key="1"
              onClick={() => handleMenuClick("/dashboard")}
              icon={
                <BusinessCenterOutlinedIcon
                  style={{
                    fontSize: "27px",
                    color: selectedKey === "1" ? "#C12328" : "black",
                    backgroundColor:
                      selectedKey === "1" ? "#FAC9CA" : "transparent",
                  }}
                />
              }
            >
              <Link
                to="/dashboard"
                style={{
                  fontWeight: selectedKey === "1" ? "bold" : "normal",
                  color: selectedKey === "1" ? "#C12328" : "black",
                }}
              >
                Clients
              </Link>
            </Menu.Item>
            <Menu.Item
              key="2"
              onClick={() => handleMenuClick("/user")}
              icon={
                <PeopleAltOutlinedIcon
                  style={{
                    fontSize: "27px",
                    color: selectedKey === "2" ? "#C12328" : "black",
                    backgroundColor:
                      selectedKey === "2" ? "#FAC9CA" : "transparent",
                  }}
                />
              }
            >
              <Link
                to="/user"
                style={{
                  fontWeight: selectedKey === "2" ? "bold" : "normal",
                  color: selectedKey === "2" ? "#C12328" : "black",
                }}
              >
                Users
              </Link>
            </Menu.Item>
          </Menu>
        ) : (
          // Project Architect Sidebar
          <Menu
            mode="inline"
            selectedKeys={[selectedKey]}
            style={{
              border: "none",
              background: "none",
              marginTop: "0px", // Changed from 60px to 0px since we have the header now
            }}
          >
            <Menu.Item
              key="1"
              onClick={() => handleMenuClick("/architect")}
              icon={
                <HomeOutlined
                  style={{
                    fontSize: "30px",
                    color: selectedKey === "1" ? "#C12328" : "black",
                    backgroundColor:
                      selectedKey === "1" ? "#FAC9CA" : "transparent",
                  }}
                />
              }
            >
              <Link
                to="/architect"
                style={{
                  fontWeight: selectedKey === "1" ? "600" : "normal",
                  color: selectedKey === "1" ? "#C12328" : "black",
                }}
              >
                Home
              </Link>
            </Menu.Item>

            <Menu.Item
              key=" 2"
              onClick={handleLocationMasterDownload}
              icon={
                <LocationOnOutlinedIcon
                  style={{
                    fontSize: "27px",
                    color: selectedKey === "2" ? "#C12328" : "black",
                    backgroundColor:
                      selectedKey === "2" ? "#FAC9CA" : "transparent",
                  }}
                />
              }
            >
              <Link
                // to="/reports"
                // className="flex flex-col leading-tight"
                style={{
                  fontWeight: selectedKey === "2" ? "bold" : "normal",
                  color: selectedKey === "2" ? "#C12328" : "black",
                }}
              >
                <span>Geo Index</span>
                {/* <span>Master</span> */}
              </Link>
            </Menu.Item>

            {/*<Menu.Item
              key=" 2"
              onClick={() => handleMenuClick("/reports")}
              icon={
                <SaveOutlined
                  style={{
                    fontSize: "27px",
                    color: selectedKey === "2" ? "#C12328" : "black",
                    backgroundColor:
                      selectedKey === "2" ? "#FAC9CA" : "transparent",
                  }}
                />
              }
            >
              <Link
                to="/reports"
                style={{
                  fontWeight: selectedKey === "2" ? "bold" : "normal",
                  color: selectedKey === "2" ? "#C12328" : "black",
                }}
              >
                Reports
              </Link>
            </Menu.Item> */}
          </Menu>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
